import WorkspaceChangedModal from "./WorkspaceChangedModal";

export default WorkspaceChangedModal;
